import React, { FormEvent } from "react";
import { Grid } from "@mui/material";
import { get } from "lodash";
import { connect } from "react-redux";
import { Field, FieldProps } from "formik";
import { ConfigPropExtenderHoc } from "../../../../../common/StaticConfigProvider";
import OptionalToolTip from "../../../../../common/toolTip/OptionalToolTip";
import pageStyles from "./../../../../../pages/pageStyles";
import { Data } from "../../../../../store/terminal/types";
import TextInput from "../../../../../common/formElements/TextInput";

interface ConfigOption {
  label: string;
  field: string;
  labelTooltip: string;
  onInput: (e: FormEvent<HTMLInputElement>) => void;
  tooltip?: string;
}

interface ConfigOptionHoc {
  label: string;
  field: string;
  onInput: (e: FormEvent<HTMLInputElement>) => void;
  labelTooltip: string;
}

interface ConfigurationProps {
  options: ConfigOption[];
  values?: Data;
  isUpdateAllowed?: boolean;
  shouldHideField?: (fieldName: string) => boolean;
}

interface ConfigurationHocProps {
  options: ConfigOptionHoc[];
  toolTips?: { terminals?: { options?: Record<string, string> } };
  shouldHideField?: (fieldName: string) => boolean;
}

const ConfigurationQantas = ({
  options,
  values,
  isUpdateAllowed,
  shouldHideField,
}: ConfigurationProps) => {
  const classes = pageStyles();
  const hasLogo =
    values &&
    values.attributes.QantasLoyaltyLogoUrl &&
    values.attributes.QantasLoyaltyLogoUrl !== "";

  // Filter out options that should be hidden
  const visibleOptions = shouldHideField 
    ? options.filter(option => !shouldHideField(option.field))
    : options;

  return (
    <Grid container spacing={2}>
      {visibleOptions.map((option, idx) => (
        <Grid item xs={12} md={hasLogo ? 5 : 6} key={idx}>
          <Field name={option.field}>
            {({ field }: FieldProps) => (
              <OptionalToolTip tooltip={option.tooltip}>
                <TextInput
                  fieldname={field.name}
                  label={option.label}
                  onInput={(e) => option.onInput(e)}
                  disabled={!isUpdateAllowed}
                />
              </OptionalToolTip>
            )}
          </Field>
        </Grid>
      ))}
      {hasLogo ? (
        // @ts-ignore
        <Grid container alignItems="center" spacing={2} md={hasLogo && 2}>
          <Grid item xs={12}>
            <img
              src={values?.attributes.QantasLoyaltyLogoUrl}
              className={classes.isImg}
            />
          </Grid>
        </Grid>
      ) : null}
    </Grid>
  );
};

const ConnectedConfigurationQantas = connect(
  null,
  null,
  (_stateProps, _dispatchProps, ownProps: ConfigurationHocProps) => {
    return {
      ...ownProps,
      shouldHideField: ownProps.shouldHideField,
      options: (ownProps?.options || []).map(
        ({ label, field, labelTooltip, onInput }) => ({
          label,
          field,
          labelTooltip,
          onInput,
          tooltip: get(
            ownProps,
            `toolTips.terminals.options.configuration.["${labelTooltip}"]`
          ),
        })
      ),
    };
  }
)(ConfigurationQantas);

const ConnectedConfigurationQantasHoc = (props: ConfigurationProps) => (
  // @ts-ignore
  <ConfigPropExtenderHoc propName="toolTips">
    <ConnectedConfigurationQantas {...props} />
  </ConfigPropExtenderHoc>
);

export default ConnectedConfigurationQantasHoc;
